import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { handleActions } from "redux-actions";
import React from "react";
import actions from "../actions/catalog";
import { filterProducts } from "@Src_main/utils/productFilters";
import { applyOnlyItemAtPriceFilter, applyOnlyItemAtPriceToProducts, resolveOnlyItemAtPriceFromContext } from "@Src_main/utils/onlyItemAtPrice";
export const name = "catalog";
const computeFilteredCatalog = state => {
  const productsWithOverrides = applyOnlyItemAtPriceToProducts(state.products, state.onlyItemAtPriceWhitelist);
  const stickerFilteredProducts = filterProducts(state.filters, productsWithOverrides, productsWithOverrides);
  return applyOnlyItemAtPriceFilter(stickerFilteredProducts, productsWithOverrides, state.onlyItemAtPriceWhitelist);
};
const fromPairs = pairs => {
  const result = {};
  for (const [key, value] of pairs) {
    result[key] = value;
  }
  return result;
};
const BenCottaIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M8.99854 17C8.02729 17 7.11806 16.816 6.27083 16.4479C5.42361 16.0799 4.68403 15.5799 4.05208 14.9479C3.42014 14.316 2.92014 13.5759 2.55208 12.7277C2.18403 11.8795 2 10.9698 2 9.99854C2 9.02729 2.18403 8.11806 2.55208 7.27083C2.92014 6.42361 3.42014 5.68403 4.05208 5.05208C4.68403 4.42014 5.42396 3.92014 6.27187 3.55208C7.11979 3.18403 8.02917 3 9 3C9.16667 3 9.33264 3.00694 9.49792 3.02083C9.66319 3.03472 9.83056 3.05556 10 3.08333V4.60417C9.84722 4.57639 9.68403 4.55208 9.51042 4.53125C9.33681 4.51042 9.16667 4.5 9 4.5C7.48611 4.5 6.19097 5.03819 5.11458 6.11458C4.03819 7.19097 3.5 8.48611 3.5 10C3.5 11.5139 4.03819 12.809 5.11458 13.8854C6.19097 14.9618 7.48611 15.5 9 15.5C10.5139 15.5 11.809 14.9618 12.8854 13.8854C13.9618 12.809 14.5 11.5139 14.5 10C14.5 9.83333 14.4896 9.66319 14.4688 9.48958C14.4479 9.31597 14.4236 9.15278 14.3958 9H15.9167C15.9444 9.16667 15.9653 9.33333 15.9792 9.5C15.9931 9.66667 16 9.83333 16 10C16 10.9708 15.816 11.8802 15.4479 12.7281C15.0799 13.576 14.5799 14.316 13.9479 14.9479C13.316 15.5799 12.5759 16.0799 11.7277 16.4479C10.8795 16.816 9.96979 17 8.99854 17ZM11.3542 13.4792L8.25 10.375V6H9.75V9.75L12.4167 12.4167L11.3542 13.4792ZM14.25 7V4.75H12V3.25H14.25V1H15.75V3.25H18V4.75H15.75V7H14.25Z",
  fill: "#1A1919"
})));
const initialState = {
  categories: {},
  sections: [],
  crossSellProducts: {},
  currentPage: 1,
  pageSize: 6,
  prevPageTotal: null,
  products: [],
  cookingTimes: [{
    id: "al_dente",
    name: "Al dente",
    description: "La pasta al dente rimane soda e piacevole."
  }, {
    id: "ben_cotta",
    name: "Ben cotta",
    description: "Pasta ben cotta, per chi la preferisce morbida.",
    modifier_title: "COTTURA_CLIENTE",
    modifier_option_title: "BEN COTTA",
    icon: BenCottaIcon
  }],
  catalogHash: "",
  modifiers: {
    ingredients: ["Exclude Ingredients"],
    topping: ["MOD_TOPPING", "MOD_TOPPING BABY", "GELATO_AGGIUNTE"],
    grattugiati: ["MOD_GRATTU", "MOD_GRATTU BABY"],
    bread: ["MOD_PANE"],
    condimento: ["MOD_CONDIMENTO", "GELATO1", "GELATO2", "GELATO3"],
    excluded_modifiers: ["DELIVERY_CONDIMENTO"],
    cookingTimings: ["COTTURA_CLIENTE"],
    courseService: ["PORTATA_CST", "Portata richiesta dal cliente"]
  },
  filters: {
    ls_web_allergeni: {
      values: [],
      type: "filterByAllergen",
      visible_filter: false
    },
    ls_web_tracce_allergeni: {
      values: [],
      type: "filterByAllergen",
      visible_filter: false
    },
    ls_dish_stickers: {
      values: [],
      type: "filterByAttribute",
      correlated_filters: {
        vegan: ["vegetariano"]
      },
      disabled_filters: [],
      visible_filter: true
    },
    member_attribute_availability: {
      values: [],
      type: "filterByMemberAttribute",
      visible_filter: false
    }
  },
  filterPanel: {
    isOpen: false,
    hasBeenClicked: false,
    isTogglingOpen: false
  },
  filtered_products: [],
  filtered_sku: [],
  orderable_sku: [],
  onlyItemAtPriceWhitelist: typeof window !== "undefined" ? resolveOnlyItemAtPriceFromContext(window.location.search, new URLSearchParams(window.location.search).get("cps")) : null,
  myoSelection: {
    products: {},
    options: [],
    productsFlat: [],
    originalProduct: null,
    price: 0
  },
  lastModalOpenSetter: () => {},
  mainMyoModalOpen: false
};
const reducerMap = {
  [actions.updateCategories]: (state, _ref) => {
    let {
      payload
    } = _ref;
    const {
      id
    } = payload;
    const currentCategory = state.categories[id] || {};

    // if category has already been fetched, do nothing
    if (currentCategory.children) {
      return state;
    }

    // sort children by `position`
    const children = [...payload.children].sort((a, b) => {
      if (a.position > b.position) {
        return 1;
      } else if (a.position === b.position && a.id > b.id) {
        return 1;
      } else {
        return -1;
      }
    });

    // use a Map to preserve sort order
    // since a plain object with numeric keys would lose it
    const childMap = new Map();

    // merge children and add them to the Map, keyed by `id`
    for (const child of children) {
      childMap.set(child.id, _objectSpread(_objectSpread(_objectSpread({}, child), state.categories[child.id] || {}), {}, {
        parentId: id
      }));
    }

    // merge in the fetched child last
    return _objectSpread(_objectSpread({}, state), {}, {
      categories: _objectSpread(_objectSpread(_objectSpread({}, state.categories), fromPairs(childMap)), {}, {
        [id]: _objectSpread(_objectSpread(_objectSpread({}, currentCategory), payload), {}, {
          children: [...childMap.keys()],
          children_count: childMap.size
        })
      })
    });
  },
  [actions.setCurrentPage.receive]: (state, _ref2) => {
    let {
      payload,
      error
    } = _ref2;
    if (error) {
      return state;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      currentPage: payload
    });
  },
  [actions.setPrevPageTotal.receive]: (state, _ref3) => {
    let {
      payload,
      error
    } = _ref3;
    if (error) {
      return state;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      prevPageTotal: payload
    });
  },
  [actions.setProductCatalog.receive]: (state, _ref4) => {
    let {
      payload,
      error
    } = _ref4;
    if (error) {
      return state;
    }
    const products = applyOnlyItemAtPriceToProducts(payload, state.onlyItemAtPriceWhitelist);
    const nextState = _objectSpread(_objectSpread({}, state), {}, {
      products
    });
    const {
      filtered_products,
      filtered_sku,
      orderable_sku
    } = computeFilteredCatalog(nextState);
    return _objectSpread(_objectSpread({}, nextState), {}, {
      filtered_products,
      filtered_sku,
      orderable_sku
    });
  },
  [actions.setCatalogHash.receive]: (state, _ref5) => {
    let {
      payload
    } = _ref5;
    return _objectSpread(_objectSpread({}, state), {}, {
      catalogHash: payload
    });
  },
  [actions.setFilters.receive]: (state, _ref6) => {
    let {
      payload,
      error
    } = _ref6;
    if (error) {
      return state;
    }
    const nextState = _objectSpread(_objectSpread({}, state), {}, {
      filters: payload
    });
    const {
      filtered_products,
      filtered_sku,
      orderable_sku
    } = computeFilteredCatalog(nextState);
    return _objectSpread(_objectSpread({}, nextState), {}, {
      filtered_products,
      filtered_sku,
      orderable_sku
    });
  },
  [actions.setOnlyItemAtPriceWhitelist.receive]: (state, _ref7) => {
    let {
      payload,
      error
    } = _ref7;
    if (error) {
      return state;
    }
    const products = applyOnlyItemAtPriceToProducts(state.products, payload);
    const nextState = _objectSpread(_objectSpread({}, state), {}, {
      onlyItemAtPriceWhitelist: payload,
      products
    });
    const {
      filtered_products,
      filtered_sku,
      orderable_sku
    } = computeFilteredCatalog(nextState);
    return _objectSpread(_objectSpread({}, nextState), {}, {
      filtered_products,
      filtered_sku,
      orderable_sku
    });
  },
  [actions.setFilterPanel.receive]: (state, _ref8) => {
    let {
      payload,
      error
    } = _ref8;
    if (error) {
      return state;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      filterPanel: payload
    });
  },
  [actions.setCookingTimes.receive]: (state, _ref9) => {
    let {
      payload,
      error
    } = _ref9;
    if (error) {
      return state;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      cookingTimes: payload
    });
  },
  [actions.setSectionCatalog.receive]: (state, _ref0) => {
    let {
      payload,
      error
    } = _ref0;
    if (error) {
      return state;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      sections: payload
    });
  },
  [actions.setCrossSellProductsMiniCart.receive]: (state, _ref1) => {
    let {
      payload,
      error
    } = _ref1;
    if (error) {
      return state;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      crossSellProducts: _objectSpread(_objectSpread({}, state.crossSellProducts), {}, {
        miniCart: payload
      })
    });
  },
  [actions.setCrossSellProductsModalFirst.receive]: (state, _ref10) => {
    let {
      payload,
      error
    } = _ref10;
    if (error) {
      return state;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      crossSellProducts: _objectSpread(_objectSpread({}, state.crossSellProducts), {}, {
        modalFirst: payload
      })
    });
  },
  [actions.setCrossSellProductsModalSecond.receive]: (state, _ref11) => {
    let {
      payload,
      error
    } = _ref11;
    if (error) {
      return state;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      crossSellProducts: _objectSpread(_objectSpread({}, state.crossSellProducts), {}, {
        modalSecond: payload
      })
    });
  },
  [actions.setCrossSellProductsBeforeCartModalFirst.receive]: (state, _ref12) => {
    let {
      payload,
      error
    } = _ref12;
    if (error) {
      return state;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      crossSellProducts: _objectSpread(_objectSpread({}, state.crossSellProducts), {}, {
        beforeCartModalFirst: payload
      })
    });
  },
  [actions.setCrossSellProductsBeforeCartModalSecond.receive]: (state, _ref13) => {
    let {
      payload,
      error
    } = _ref13;
    if (error) {
      return state;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      crossSellProducts: _objectSpread(_objectSpread({}, state.crossSellProducts), {}, {
        beforeCartModalSecond: payload
      })
    });
  },
  [actions.setMyoSelection.receive]: (state, _ref14) => {
    let {
      payload,
      error
    } = _ref14;
    if (error) {
      return state;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      myoSelection: payload
    });
  },
  [actions.setLastModalOpenSetter.receive]: (state, _ref15) => {
    let {
      payload,
      error
    } = _ref15;
    if (error) {
      return state;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      lastModalOpenSetter: payload
    });
  },
  [actions.setMainMyoModalOpen.receive]: (state, _ref16) => {
    let {
      payload,
      error
    } = _ref16;
    if (error) {
      return state;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      mainMyoModalOpen: payload
    });
  }
};
export default handleActions(reducerMap, initialState);